export default __webpack_public_path__ + "static/media/tl6.b1789cb5.webp";